const RECAPTCHA_ACTION = "subscribe_newsletter";

const RECAPTCHA_MESSAGE =
  "The security check could not complete. Try refreshing the page. If this persists, the site may need a valid reCAPTCHA key for this domain.";

const VERIFY_MESSAGE =
  "We couldn't verify this signup. Refresh the page and try again.";

const GENERIC_MESSAGE = "Something went wrong. Please try again in a moment.";

export async function executeNewsletterRecaptcha(
  executeRecaptcha: (action: string) => Promise<string>
) {
  try {
    return await executeRecaptcha(RECAPTCHA_ACTION);
  } catch (error) {
    console.error("Newsletter reCAPTCHA error:", error);
    throw new Error(RECAPTCHA_MESSAGE);
  }
}

export function newsletterFailureMessage(
  reason: "not_found" | "client_error" | "server_error" | "network" | "missing_config"
) {
  if (reason === "client_error") return VERIFY_MESSAGE;
  return GENERIC_MESSAGE;
}

export function subscribeErrorMessage(error: unknown) {
  if (error instanceof Error && error.message) return error.message;
  return GENERIC_MESSAGE;
}
